export function isActiveUser(user) {
  return user?.permissionLogin !== false
}

export function getDownlineIds(users, userId) {
  if (!userId) return new Set()

  const childrenMap = new Map()
  for (const user of users || []) {
    if (user.reportsToUserId) {
      if (!childrenMap.has(user.reportsToUserId)) childrenMap.set(user.reportsToUserId, [])
      childrenMap.get(user.reportsToUserId).push(user.id)
    }
  }

  const downline = new Set()
  const queue = [...(childrenMap.get(userId) || [])]
  while (queue.length) {
    const id = queue.shift()
    if (!downline.has(id)) {
      downline.add(id)
      queue.push(...(childrenMap.get(id) || []))
    }
  }

  return downline
}

export function getAvailableManagerUsers(users, editingId) {
  const downlineIds = getDownlineIds(users, editingId)
  return (users || []).filter(user => user.id !== editingId && !downlineIds.has(user.id) && isActiveUser(user))
}

export function validateReportsToSelection(users, userId, reportsToUserId) {
  if (!reportsToUserId) return { valid: true }

  if (userId && reportsToUserId === userId) {
    return { valid: false, message: 'A user cannot report to themselves.' }
  }

  if (userId && getDownlineIds(users, userId).has(reportsToUserId)) {
    return { valid: false, message: 'This manager would create a circular reporting relationship.' }
  }

  const manager = (users || []).find(user => user.id === reportsToUserId)
  if (manager && !isActiveUser(manager)) {
    return { valid: false, message: 'Select an active manager.' }
  }

  return { valid: true }
}

export function getActiveReportsToValue(users, reportsToUserId) {
  if (!reportsToUserId) return null

  const manager = (users || []).find(user => user.id === reportsToUserId)
  return manager && isActiveUser(manager) ? reportsToUserId : null
}

export function buildActiveManagerHierarchy(users) {
  const userMap = new Map((users || []).map(user => [user.id, user]))
  const childrenMap = new Map()
  const hasParent = new Set()
  const hasChildren = new Set()

  for (const user of users || []) {
    if (!user.reportsToUserId) continue

    const manager = userMap.get(user.reportsToUserId)
    if (!manager || !isActiveUser(manager)) continue

    hasParent.add(user.id)
    hasChildren.add(manager.id)
    if (!childrenMap.has(manager.id)) childrenMap.set(manager.id, [])
    childrenMap.get(manager.id).push(user)
  }

  return { childrenMap, hasParent, hasChildren }
}

export function isOutsideActiveHierarchy(user, hierarchy, ownerUserId) {
  if (!user || user.id === ownerUserId) return false
  return !hierarchy.hasParent.has(user.id) && !hierarchy.hasChildren.has(user.id)
}
